/**
 * Webpack entry: bundles React layout and Tailwind CSS.
 */
import '../styles/tailwind.css';
import '../styles/additional.scss';

// Sections
import { setupProductAdditionals } from './sections/product.js';

import './layout.jsx';

document.addEventListener('DOMContentLoaded', () => {
  setupProductAdditionals()
})